import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ProductService {
	onChangeProductType = new Subject<boolean>();
	editRoom = new Subject<boolean>();
	additionalChargeChange = new Subject<boolean>();
	data = this.cleanData();
	mockData = this.cleanMockData();
	checkExit: boolean;

	dataLoaded$: Subject<void> = new Subject();

	readonly refreshRooms$ = new Subject<void>();

	cleanData() {
		return {
			id: null,
			productKind: null,
			organization: null,
			board: null,
			allowedDocuments: null,
			surchargeBoard: {
				currency: 1,
				fee: null,
			},
			stop: null,
			name: null,
			status: 'D',
			code: null,
			zipCode: '',
			address: '',
			buildingNumber: '',
			tags: [],
			location: [],
			conveniences: [],
			descriptions: [],
			longitude: null,
			latitude: null,
			surchargeProgram: {
				id: 0,
				description: '',
			},
			nightsStay: null,
			organizationNote: null,
			priceSetting: null,
			productMultimedias: [],
			rooms: [],
			stars: 0,
			insurer: null,
			insurance: null,
			isNightEvent: false,
			cards: [],
			hotels: [],
			guides: [],
			tickets: [],
			checkpoints: [],
			checkpointGroups: [],
			costs: [],
		};
	}

	cleanMockData() {
		return {
			tags: null,
			productKind: null,
			organization: null,
			location: null,
			board: null,
			allowedDocuments: null,
			stops: null,
			convenience: null,
			currency: null,
			code1: null,
			code2: null,
			code3: null,
			roomType: null,
			coordinates: null,
			mockName: null,
		};
	}

	resetData(): void {
		this.data = this.cleanData();
		this.mockData = this.cleanMockData();
	}
}
